"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const react_1 = __importDefault(require("react"));
const react_native_switch_toggle_1 = __importDefault(require("react-native-switch-toggle"));
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const base_ui_theme_colors_1 = require("@unboared/base-ui.theme.colors");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
function Switch({ checked, toggle, size = 20 }) {
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const theme = (0, base_ui_theme_themes_1.useTheme)();
    return (react_1.default.createElement(react_native_switch_toggle_1.default, { switchOn: checked, onPress: toggle, circleColorOff: (0, base_ui_theme_colors_1.transparency)(theme.mode, 0.2), circleColorOn: theme.color.light, backgroundColorOff: (0, base_ui_theme_colors_1.transparency)(theme.mode), backgroundColorOn: theme.buttonColor, containerStyle: {
            width: normalize(2 * size),
            height: normalize(size),
            borderRadius: normalize(2 * size),
            padding: normalize(0.15 * size),
        }, circleStyle: {
            width: normalize(0.8 * size),
            height: normalize(0.8 * size),
            borderRadius: normalize(size),
        } }));
}
exports.Switch = Switch;
//# sourceMappingURL=switch.js.map